/* dl-product.js — design—light PDP · export 03
   Variant matching, gallery focus, selling-plan pricing, qty.

   No hardcoded discount. The preorder price and the "-N %" badge are read from
   the variant's real selling_plan_allocation, so a vendor whose plan is 5 % or
   12 % is correct with no code change (handoff 02 §4 / DISCOUNT = 0.08 removed).

   Contract with the markup (all declarative, nothing positional):
     [data-dl-product]                  section root
     [data-dl-payload]                  <script type="application/json"> variant data
     [data-dl-opt="<i>"]                option group, i = index in product.options
     [data-dl-opt] .o[data-v]           option value tile
     .ogrid[--cols]                     packed tile grid; JS writes grid-column
     .swgrid                            colour chips, chip only, not packed
     [data-dl-optlabel="<i>"]           text node showing the chosen value
     [data-dl-plans] .o[data-plan]      availability group; data-plan="0" = buy now
     [data-dl-vid] / [data-dl-plan]     hidden form inputs (id / selling_plan)
     [data-dl-specfrom="<option name>"] spec row value mirroring an option
     .gal .sh[data-media]               gallery cell, media position
     .gal.cap / .sh.over                capped gallery; [data-dl-galmore] reveals
*/
(function () {
  var roots = document.querySelectorAll("[data-dl-product]");
  for (var r = 0; r < roots.length; r++) init(roots[r]);

  function init(root) {
    var payloadEl = root.querySelector("[data-dl-payload]");
    if (!payloadEl) return;
    var data;
    try { data = JSON.parse(payloadEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    if (!variants.length) return;

    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var groups = $$("[data-dl-opt]");
    var planGroup = $("[data-dl-plans]");
    var vidInput = $("[data-dl-vid]");
    var planInput = $("[data-dl-plan]");
    var priceEl = $("[data-dl-price]");
    var stockEl = $("[data-dl-stock]");

    /* 2026-08-22: "Skladem" must mean real stock. Shopify reports a variant as
       available whenever its policy is CONTINUE, which every preorder-enabled
       product uses, so v.available alone printed "Skladem, odesíláme do 24 h"
       on ~1230 active products holding nothing. Untracked variants count as in
       stock: not tracking is a deliberate merchant choice, not a zero. */
    function hasStock(v) { return !!v && v.available && (!v.tracked || v.qty > 0); }
    var cartBtn = $("[data-dl-submit]");
    var gal = $(".gal");
    var galWrap = $(".galwrap");
    var gcount = $("[data-dl-gcount]");
    var pbar = $("[data-dl-pbar]");
    var pbarImg = $("[data-dl-pbar-img]");
    var pbarPrice = $("[data-dl-pbar-price]");

    /* current selection = one value per option index */
    var sel = [];
    groups.forEach(function (g) {
      var i = +g.getAttribute("data-dl-opt");
      var on = g.querySelector(".o.on") || g.querySelector(".o");
      sel[i] = on ? on.getAttribute("data-v") : null;
    });

    var usePlan = false; /* false = buy now, true = selling plan */

    /* ---------- lookup helpers ---------- */
    function matches(v, partial) {
      for (var i = 0; i < partial.length; i++) {
        if (partial[i] != null && v.options[i] !== partial[i]) return false;
      }
      return true;
    }
    function findVariant(s) {
      for (var i = 0; i < variants.length; i++) if (matches(variants[i], s)) return variants[i];
      return null;
    }
    /* best candidate when a click makes the current combo impossible:
       keep the clicked option, relax later options left-to-right */
    function resolve(s, changedIndex) {
      var exact = findVariant(s);
      if (exact) return exact;
      var probe = s.slice();
      for (var i = probe.length - 1; i >= 0; i--) {
        if (i === changedIndex) continue;
        probe[i] = null;
        var hit = findVariant(probe);
        if (hit) return hit;
      }
      return findVariant([]) || variants[0];
    }

    /* ---------- pricing ---------- */
    function allocation(v) {
      return v.plans && v.plans.length ? v.plans[0] : null;
    }
    function paint(v) {
      var alloc = allocation(v);
      var planActive = usePlan && !!alloc;
      var html = "";
      if (planActive) {
        var pct = v.price > 0 ? Math.round((1 - alloc.price / v.price) * 100) : 0;
        html = "<b>" + alloc.priceF + "</b>";
        if (alloc.price < v.price) {
          html += '<span class="was">' + v.priceF + "</span>";
          if (pct > 0) html += '<span class="save">' + "−" + pct + " %</span>";
        }
        html += '<span class="vat">s DPH</span>';
      } else {
        html = "<b>" + v.priceF + "</b>";
        if (v.compare > v.price) html += '<span class="was">' + v.compareF + "</span>";
        html += '<span class="vat">s DPH' + (hasStock(v) ? " · skladem" : "") + "</span>";
      }
      if (priceEl) priceEl.innerHTML = html;

      /* stock line */
      if (stockEl) {
        var s = "";
        if (planActive) {
          s = '<span class="dot wait"></span>' + esc(alloc.name) +
            ' <span class="sub">· ' + esc(data.planNote || "dodání dle dostupnosti") + "</span>";
        } else if (v.available && v.qty > 0 && v.tracked) {
          /* 2026-09-07: the number is banded server-side (dl-product-main.liquid).
             v.qty is the band floor and v.qtyMore says the real count is above it,
             so the exact stock reaches the browser nowhere — not on screen and not
             in the payload. 1-5 exact; above that 5, 10, 50, 100. */
          s = '<span class="dot"></span>Skladem ' + (v.qtyMore ? "více než " : "") + v.qty + " ks" +
            ' <span class="sub">· ' + esc(data.shipNote || "odesíláme do 24 h") + "</span>";
        } else if (hasStock(v)) {
          s = '<span class="dot"></span>Skladem <span class="sub">· ' + esc(data.shipNote || "odesíláme do 24 h") + "</span>";
        } else if (v.available) {
          s = '<span class="dot wait"></span>' + esc(data.outStockTile || "Na objednávku") +
            ' <span class="sub">· ' + esc(data.outShipNote || "termín dodání potvrdíme") + "</span>";
        } else if (alloc) {
          s = '<span class="dot wait"></span>Pouze na objednání';
        } else if (!v.price) {
          /* 2026-08-23: price 0 means "na dotaz" (enquiry-only pages such as the
             YaYaHo system and its components). Those are not sold out, they have
             no published price, so say that instead of "Momentálně vyprodáno". */
          s = '<span class="dot wait"></span>Cena na dotaz <span class="sub">· ozvěte se nám</span>';
        } else {
          s = '<span class="dot out"></span>Momentálně vyprodáno';
        }
        stockEl.innerHTML = s;
      }

      /* cart button */
      if (cartBtn) {
        var can = planActive ? !!alloc : v.available;
        cartBtn.disabled = !can;
        cartBtn.textContent = can
          ? (data.atcLabel || "Přidat do košíku")
          : (!v.price ? "Cena na dotaz" : "Nedostupné");
      }
    }

    /* ---------- availability group ---------- */
    function syncPlanGroup(v) {
      if (!planGroup) return;
      var alloc = allocation(v);
      var buyTile = planGroup.querySelector('.o[data-plan="0"]');
      var planTile = planGroup.querySelector('.o:not([data-plan="0"])');
      /* defensive: if the markup ever ships both tiles with the same value,
         fall back to "the tile that is not the buy tile" rather than going inert */
      if (!planTile) {
        planTile = Array.prototype.filter.call(planGroup.querySelectorAll(".o"), function (o) {
          return o !== buyTile;
        })[0] || null;
      }
      if (planTile) {
        planTile.hidden = !alloc;
        if (alloc) {
          planTile.setAttribute("data-plan", alloc.id);
          var pct = v.price > 0 ? Math.round((1 - alloc.price / v.price) * 100) : 0;
          var hint = planTile.querySelector("i");
          if (hint) hint.textContent = (data.planNote || "") + (pct > 0 ? " · −" + pct + " %" : "");
        }
      }
      if (buyTile) {
        /* 2026-08-22: preorder IS the out-of-stock path. With no stock and a plan
           available, the Skladem tile greys out and Předobjednávka takes over as the
           only selectable option. With no plan it stays live, because CONTINUE means
           the order is still accepted; only then does the out-of-stock wording show. */
        var soldOut = !hasStock(v);
        var buyDis = !v.available || (soldOut && !!alloc);
        buyTile.classList.toggle("dis", buyDis);
        var bLbl = buyTile.querySelector(".lbl"), bNote = buyTile.querySelector("i");
        var keepStockWording = !soldOut || !!alloc;
        if (bLbl) bLbl.textContent = keepStockWording
          ? (data.inStockTile || "Skladem")
          : (data.outStockTile || "Na objednávku");
        if (bNote) bNote.textContent = keepStockWording
          ? (data.shipNote || "odesíláme do 24 h")
          : (data.outShipNote || "termín dodání potvrdíme");
        if (soldOut && alloc) usePlan = true;
        if (!alloc) usePlan = false;
      }
      planGroup.querySelectorAll(".o").forEach(function (o) {
        var isBuy = o.getAttribute("data-plan") === "0";
        o.classList.toggle("on", usePlan ? !isBuy : isBuy);
      });
      packAll();
      var lbl = $("[data-dl-planlabel]");
      if (lbl) {
        lbl.textContent = usePlan && alloc
          ? alloc.name
          : (hasStock(v)
              ? (data.inStockLabel || "Skladem — ihned")
              : (v.available ? (data.outStockLabel || "Na objednávku") : "Nedostupné"));
      }
    }

    /* ---------- option tiles ---------- */
    function syncOptions() {
      groups.forEach(function (g) {
        var i = +g.getAttribute("data-dl-opt");
        g.querySelectorAll(".o").forEach(function (o) {
          var val = o.getAttribute("data-v");
          o.classList.toggle("on", sel[i] === val);
          /* exists at all with the other current picks? */
          var probe = sel.slice();
          probe[i] = val;
          var hit = findVariant(probe) || findVariant(onlyAt(i, val));
          var orderable = hit && (hit.available || (hit.plans && hit.plans.length));
          o.classList.toggle("dis", !orderable);
          /* per-value price + state hint, only where the markup asked for it */
          var hint = o.querySelector("i[data-dl-hint]");
          if (hint && hit) {
            hint.textContent = hit.priceF + (hit.available ? "" : " · na objednání");
          }
        });
        var lbl = root.querySelector('[data-dl-optlabel="' + i + '"]');
        if (lbl) lbl.textContent = sel[i] || "";
      });
      /* hints just changed width */
      packAll();
    }
    function onlyAt(i, val) {
      var p = [];
      p[i] = val;
      return p;
    }

    /* ---------- gallery ---------- */
    function isMobile() { return window.matchMedia("(max-width:900px)").matches; }
    function galCells() { return gal ? Array.prototype.slice.call(gal.querySelectorAll(".sh")) : []; }
    /* Reveal the photos past the cap. Returns true if it actually opened, so
       focusMedia can expand first and then scroll to a cell that was hidden a
       moment ago — a variant must never point at a photo the customer cannot see. */
    function openGal() {
      if (!gal || !gal.classList.contains("cap")) return false;
      gal.classList.remove("cap");
      var b = $("[data-dl-galmore]");
      if (b) b.hidden = true;
      return true;
    }
    function stickyOffset() {
      var bar = document.querySelector(".catbar,[data-dl-sticky]");
      return (bar ? bar.getBoundingClientRect().height : 56) + 14;
    }
    function syncCount() {
      if (!gal || !gcount || !gal.clientWidth) return;
      var n = galCells().length;
      gcount.textContent = Math.min(n, Math.round(gal.scrollLeft / gal.clientWidth) + 1) + " / " + n;
    }
    function syncBar(cell) {
      if (!pbar) return;
      var src = cell || galCells()[0];
      var img = src ? src.querySelector("img") : null;
      if (img && pbarImg && pbarImg.src !== img.currentSrc && pbarImg.src !== img.src) {
        pbarImg.src = img.currentSrc || img.src;
      }
      var b = priceEl ? priceEl.querySelector("b") : null;
      if (b && pbarPrice) pbarPrice.textContent = b.textContent;
    }
    /* On mobile the carousel snaps sideways — no vertical jump, and the sticky
       bar shows the new photo immediately if the carousel is off-screen. */
    function focusMedia(v, scroll) {
      if (!gal) return;
      var cells = galCells();
      var hit = null;
      if (v.media != null) {
        hit = cells.filter(function (c) { return +c.getAttribute("data-media") === v.media; })[0] || null;
      }
      if (hit && hit.classList.contains("over")) openGal();
      cells.forEach(function (c) { c.classList.toggle("on", c === hit); });
      if (!hit) { syncBar(cells[0]); return; }
      if (isMobile()) {
        var i = cells.indexOf(hit);
        gal.scrollTo({ left: i * gal.clientWidth, behavior: scroll ? "smooth" : "auto" });
        syncBar(hit);
        syncCount();
        return;
      }
      syncBar(hit);
      if (scroll) {
        var y = hit.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }

    /* ---------- spec mirrors ---------- */
    function syncSpecs() {
      $$("[data-dl-specfrom]").forEach(function (el) {
        var name = el.getAttribute("data-dl-specfrom");
        var i = (data.optionNames || []).indexOf(name);
        if (i > -1 && sel[i]) el.textContent = sel[i];
      });
    }

    /* ---------- apply ---------- */
    var current = null;
    function apply(v, scrollGallery) {
      current = v;
      sel = v.options.slice();
      if (vidInput) vidInput.value = v.id;
      syncOptions();
      syncPlanGroup(v);
      if (planInput) {
        var alloc = allocation(v);
        planInput.value = usePlan && alloc ? alloc.id : "";
        planInput.disabled = !planInput.value;
      }
      paint(v);
      syncSpecs();
      focusMedia(v, scrollGallery);
      if (data.updateUrl !== false && window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set("variant", v.id);
        history.replaceState({}, "", u.toString());
      }
      root.dispatchEvent(new CustomEvent("dl:variant", { bubbles: true, detail: { variant: v, sellingPlan: planInput ? planInput.value : "" } }));
    }

    /* ---------- events ---------- */
    groups.forEach(function (g) {
      var i = +g.getAttribute("data-dl-opt");
      g.addEventListener("click", function (e) {
        var o = e.target.closest(".o");
        if (!o || o.classList.contains("dis")) return;
        var probe = sel.slice();
        probe[i] = o.getAttribute("data-v");
        var v = resolve(probe, i);
        var isColour = (data.mediaOptionIndex === i);
        apply(v, isColour);
      });
    });

    if (planGroup) {
      planGroup.addEventListener("click", function (e) {
        var o = e.target.closest(".o");
        if (!o || o.hidden || o.classList.contains("dis")) return;
        usePlan = o.getAttribute("data-plan") !== "0";
        apply(current, false);
      });
    }

    /* qty */
    var qty = $("[data-dl-q]");
    if (qty) {
      var step = function (d) {
        var n = Math.max(1, (parseInt(qty.value, 10) || 1) + d);
        qty.value = n;
      };
      var minus = $("[data-dl-qminus]"), plus = $("[data-dl-qplus]");
      if (minus) minus.addEventListener("click", function () { step(-1); });
      if (plus) plus.addEventListener("click", function () { step(1); });
      qty.addEventListener("change", function () { qty.value = Math.max(1, parseInt(qty.value, 10) || 1); });
    }

    /* gallery click -> highlight only (no navigation) */
    if (gal) {
      gal.addEventListener("click", function (e) {
        var cell = e.target.closest(".sh");
        if (!cell) return;
        gal.querySelectorAll(".sh").forEach(function (c) { c.classList.toggle("on", c === cell); });
      });
      gal.addEventListener("scroll", function () {
        if (gal._t) return;
        gal._t = setTimeout(function () { gal._t = null; syncCount(); syncBar(galCells()[Math.round(gal.scrollLeft / (gal.clientWidth || 1))]); }, 90);
      }, { passive: true });
    }

    /* sticky product bar: on once the carousel has left the viewport */
    if (galWrap && pbar && "IntersectionObserver" in window) {
      new IntersectionObserver(function (es) {
        pbar.classList.toggle("on", isMobile() && !es[0].isIntersecting);
      }, { threshold: 0 }).observe(galWrap);
    }
    var pTop = $("[data-dl-pbar-top]");
    if (pTop) pTop.addEventListener("click", function (e) {
      e.preventDefault();
      var y = galWrap.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
      window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
    });
    var pGo = $("[data-dl-pbar-go]");
    if (pGo) pGo.addEventListener("click", function () {
      var buy = $(".buy");
      if (!buy) return;
      window.scrollTo({ top: buy.getBoundingClientRect().top + window.pageYOffset - stickyOffset() - 62, behavior: "smooth" });
    });
    var galMore = $("[data-dl-galmore]");
    if (galMore) galMore.addEventListener("click", function () { openGal(); syncCount(); });
    syncCount();
    addEventListener("resize", function () { clearTimeout(gal && gal._r); if (gal) gal._r = setTimeout(syncCount, 140); });

    /* boot from ?variant= or the server-selected variant */
    var boot = null;
    var qsv = new URLSearchParams(window.location.search).get("variant");
    if (qsv) boot = variants.filter(function (v) { return String(v.id) === qsv; })[0];
    if (!boot && data.selected) boot = variants.filter(function (v) { return v.id === data.selected; })[0];
    if (!boot) boot = variants.filter(function (v) { return v.available; })[0] || variants[0];
    usePlan = !hasStock(boot) && !!allocation(boot);
    apply(boot, false);
  }


  /* Sticky info panel, but only when it actually fits.
     A panel taller than the viewport would pin with its bottom unreachable, so
     it reverts to scrolling with the page. Re-measured on resize, on font load
     and whenever a variant change alters the panel height. */
  function fitSticky() {
    var bar = document.querySelector(".catbar,[data-dl-sticky]");
    var off = (bar ? bar.getBoundingClientRect().height : 56) + 12;
    var panels = document.querySelectorAll(".istick");
    for (var i = 0; i < panels.length; i++) {
      var el = panels[i];
      el.classList.remove("nostick");
      if (el.scrollHeight > window.innerHeight - off) el.classList.add("nostick");
    }
  }
  fitSticky();
  var fitT = null;
  addEventListener("resize", function () { clearTimeout(fitT); fitT = setTimeout(fitSticky, 120); });
  addEventListener("dl:variant", function () { clearTimeout(fitT); fitT = setTimeout(fitSticky, 60); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitSticky);


  /* ---------- option tile packing ----------
     Every .ogrid row ends exactly on the track count. A tile whose label is wider
     than one track takes span 2, 3, … up to the full width; whatever columns are
     left over at the end of a row are handed back to that row's tiles round-robin,
     so there is never an empty cell showing the seam colour.

     Widening is measured from the text, not guessed: a Range over the label
     reports the full inline width even when the label is ellipsised, so this is
     stable whether or not the tile currently fits. Only single-line children are
     measured — a wrapping note must not demand width it can fold instead.

     Re-run on resize, on font load, and after any variant change that rewrites a
     price hint, since all three change the measured width. */
  function packGrid(g) {
    var tiles = Array.prototype.filter.call(g.querySelectorAll(".o"), function (t) { return !t.hidden; });
    if (!tiles.length) return;
    var cs = getComputedStyle(g);
    var cols = parseInt(cs.getPropertyValue("--cols"), 10) || 0;
    if (!cols) return;
    var seam = parseFloat(cs.columnGap) || 0;
    var inner = g.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    var colW = (inner - (cols - 1) * seam) / cols;
    if (!(colW > 0)) return;

    var rng = document.createRange();
    var need = tiles.map(function (t) {
      t.style.gridColumn = "";
      var pad = 26;
      var ts = getComputedStyle(t);
      pad = (parseFloat(ts.paddingLeft) || 0) + (parseFloat(ts.paddingRight) || 0);
      var wid = 0;
      var single = t.querySelectorAll(".lbl,i[data-dl-hint]");
      if (!single.length) { rng.selectNodeContents(t); wid = rng.getBoundingClientRect().width; }
      else Array.prototype.forEach.call(single, function (el) {
        rng.selectNodeContents(el);
        wid = Math.max(wid, rng.getBoundingClientRect().width);
      });
      /* n tracks hold n*colW + (n-1)*seam */
      var n = Math.ceil((wid + pad + seam - 0.5) / (colW + seam));
      return Math.max(1, Math.min(cols, n));
    });

    var rows = [], row = [], sum = 0;
    need.forEach(function (n, i) {
      if (sum + n > cols && row.length) { rows.push({ idx: row, sum: sum }); row = []; sum = 0; }
      row.push(i); sum += n;
    });
    if (row.length) rows.push({ idx: row, sum: sum });
    rows.forEach(function (r) {
      var left = cols - r.sum, k = 0;
      while (left > 0) { need[r.idx[k % r.idx.length]]++; left--; k++; }
    });
    tiles.forEach(function (t, i) { t.style.gridColumn = "span " + need[i]; });
  }
  var packQueued = false;
  function packAll() {
    if (packQueued) return;
    packQueued = true;
    /* setTimeout, not requestAnimationFrame: rAF does not run in a hidden tab or
       an offscreen iframe, which would leave the grid unpacked until it was
       focused. This has to be correct before first paint, not after. */
    setTimeout(function () {
      packQueued = false;
      Array.prototype.forEach.call(document.querySelectorAll(".ogrid"), packGrid);
    }, 0);
  }
  window.addEventListener("resize", packAll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(packAll);
  /* The grid is measured, so it has to be packed once it HAS a measurement. At
     first paint the buy panel has no width yet, and with a system font stack
     document.fonts.ready resolves before layout — both initial hooks can land on
     a zero-width grid and bail. A ResizeObserver fires exactly when the width
     becomes real, and again on every later change. Spans do not alter the grid's
     own width, so this cannot feed back on itself. */
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(packAll);
    document.addEventListener("DOMContentLoaded", function () {
      Array.prototype.forEach.call(document.querySelectorAll(".ogrid"), function (g) { ro.observe(g); });
    });
    if (document.readyState !== "loading") Array.prototype.forEach.call(document.querySelectorAll(".ogrid"), function (g) { ro.observe(g); });
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
})();
